/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarEventExclusion } from '../../models/calendar-event-exclusion';
import { CalendarEventExclusionNew } from '../../models/calendar-event-exclusion-new';

export interface CreateEventExclusions$Params {

/**
 * Id of a calendar event.
 */
  eventId: string;
      body: CalendarEventExclusionNew
}

export function createEventExclusions(http: HttpClient, rootUrl: string, params: CreateEventExclusions$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventExclusion>> {
  const rb = new RequestBuilder(rootUrl, createEventExclusions.PATH, 'post');
  if (params) {
    rb.path('eventId', params.eventId, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendarEventExclusion>;
    })
  );
}

createEventExclusions.PATH = '/api/v1/calendarEvents/{eventId}/exclusions';
